import { isNumber, validationUtils } from "@zickko/shared";
import { Result } from "nutso";
import React, { useEffect, useState } from "react";

export type NumberInputProps = {
  value: number | undefined;
  onChange: (value?: number) => void;
  validation?: Result<number>;
  disabled?: boolean;
  dataCy?: string;
  step?: string;
  customRef?: React.RefObject<HTMLInputElement>;
  inputMode?: "numeric" | "decimal";
};

export const NumberInput = (props: NumberInputProps) => {
  const initialValue = isNumber(props.value) ? props.value : "";
  // console.log(props, initialValue);
  const [value, setValue] = useState(initialValue);
  const { validation = validationUtils.success } = props;

  useEffect(() => {
    setValue(props.value ?? "");
  }, [props.value]);

  return (
    <input
      type="number"
      step={props.step}
      value={value}
      onChange={(e) => {
        // always bind to the local state
        setValue(e.target.value);

        // if value is number then, call onChange
        if (isNumber(e.target.valueAsNumber)) {
          props.onChange(e.target.valueAsNumber);
          return;
        }

        // if value is empty string, then pass undefined
        if (e.target.value === "") {
          props.onChange();
          return;
        }
      }}
      className={validation.isValid ? "valid" : "invalid"}
      disabled={props.disabled}
      data-cy={props.dataCy}
      ref={props.customRef}
      inputMode={props.inputMode ?? "numeric"}
    />
  );
};
